import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarMonthRowFn = /* @__PURE__ */ createRecipe('calendar-month-row', {}, [])

const calendarMonthRowVariantMap = {}

const calendarMonthRowVariantKeys = Object.keys(calendarMonthRowVariantMap)

export const calendarMonthRow = /* @__PURE__ */ Object.assign(memo(calendarMonthRowFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarMonthRow',
  __getCompoundVariantCss__: calendarMonthRowFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarMonthRowVariantKeys,
  variantMap: calendarMonthRowVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarMonthRowVariantKeys)
  },
  getVariantProps: calendarMonthRowFn.getVariantProps,
})